export default "__VITE_ASSET__d246bf9e__"